module.exports = __webpack_public_path__ + "img/tickets.1d047e35.svg";